import type { PropsWithChildren, ReactNode } from 'react'
import { useState } from 'react'

import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import Accordion from '@mui/material/Accordion'
import AccordionDetails from '@mui/material/AccordionDetails'
import AccordionSummary from '@mui/material/AccordionSummary'
import Toolbar from '@mui/material/Toolbar'
import Typography from '@mui/material/Typography'

export { StyledExpandCard }

type Props = PropsWithChildren<{
  title: string
  buttonBar?: ReactNode
  collapsed?: boolean
}>

const StyledExpandCard = ({
  children,
  title,
  buttonBar,
  collapsed = false,
}: Props) => {
  const [expanded, setExpanded] = useState(!collapsed)

  return (
    <Accordion
      sx={{ mb: 2 }}
      onChange={() => {
        setExpanded(!expanded)
      }}
      expanded={expanded}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography
          variant="h5"
          sx={{
            color: '#1a4d99',
            fontFamily: 'Aller',
            fontSize: '24px',
            fontWeight: 200,
            marginLeft: '8px',
            padding: '24px',
            width: '100%',
          }}
        >
          {title}
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ width: '95%', mx: 'auto', pb: 7 }}>
        {buttonBar && (
          <Toolbar
            sx={{
              backgroundColor: '#F7F7F7',
              borderBottom: '1px solid #E0E0E0',
              justifyContent: 'flex-end',
            }}
          >
            {buttonBar}
          </Toolbar>
        )}
        {children}
      </AccordionDetails>
    </Accordion>
  )
}
